import { Box } from '@chakra-ui/react'
import React from 'react'
import { ActionItemFieldsFragment } from '~graphql/generated/graphql'

export default function BoardingContent({
    actionItem,
}: {
    actionItem: ActionItemFieldsFragment
}) {
    return <Box>Boarding</Box>
}
